import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";

export default function NotFound({
  title = "Halaman Tidak Ditemukan",
  message = "Halaman yang Anda cari tidak ada atau sudah dipindahkan.",
  backTo = "/",
  backLabel = "Kembali ke Beranda",
}) {
  return (
    <div className="min-h-screen bg-background" data-testid="not-found-page">
      <Seo title="404 — Halaman Tidak Ditemukan | Travele" description={message} noindex />
      <Navbar />
      <div className="mx-auto max-w-3xl px-4 py-32 text-center">
        <h1 className="font-display text-6xl font-black text-primary">404</h1>
        <p className="mt-4 font-display text-2xl font-bold">{title}</p>
        <p className="mt-2 text-muted-foreground">{message}</p>
        <Link
          to={backTo}
          data-testid="notfound-home-link"
          className="mt-6 inline-block rounded-md bg-primary px-6 py-3 font-bold text-primary-foreground transition-transform hover:-translate-y-0.5"
        >
          {backLabel}
        </Link>
      </div>
      <Footer />
    </div>
  );
}
